import { useTranslation } from 'react-i18next';
import * as styles from './index.module.css';

/**
 * Generic empty state component
 * @param {Object} props
 * @param {string} props.type - Type of empty state: 'no-data' | 'error' | 'loading' | 'custom'
 * @param {string} props.message - Custom message to display
 * @param {string} props.translationKey - Translation key for the message
 * @param {ReactNode} props.icon - Custom icon to display
 * @param {ReactNode} props.children - Additional content to display
 * @param {string} props.className - Additional CSS class for custom styling
 */
export default function EmptyState({
  type = 'no-data',
  message,
  translationKey,
  icon,
  children,
  className,
}) {
  const { t } = useTranslation();

  const getDefaultMessage = () => {
    if (translationKey) {
      return t(translationKey);
    }
    switch (type) {
      case 'no-data':
        return t('common.emptyState.noData');
      case 'error':
        return t('common.emptyState.error');
      case 'loading':
        return t('common.loading');
      default:
        return message || t('common.emptyState.default');
    }
  };

  const displayMessage = message || getDefaultMessage();

  const typeClass = type === 'error' ? styles.error : '';

  return (
    <div className={`${styles.emptyState} ${typeClass}${className ? ` ${className}` : ''}`}>
      {icon && <div className={styles.icon}>{icon}</div>}
      <p className={styles.message}>{displayMessage}</p>
      {children && <div className={styles.content}>{children}</div>}
    </div>
  );
}
